import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivBackgroundImage = styled.div<{
  packageImageUrl: string;
  borderTopRadius?: number;
  borderBottomRadius?: number;
  isVodDetail: boolean;
}>`
  background-image: url(${({ packageImageUrl }) => packageImageUrl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  padding-top: 56.25%;
  // MEMO : 画面幅が大きい時の対応のため、max-widthを指定する
  max-width: 1025px;
  width: 100%;

  ${({ borderTopRadius }) =>
    borderTopRadius &&
    `
      border-top-left-radius: ${borderTopRadius}px;
      border-top-right-radius: ${borderTopRadius}px;
    `}

  ${({ borderBottomRadius }) =>
    borderBottomRadius &&
    `
      border-top-left-radius: ${borderBottomRadius}px;
      border-top-right-radius: ${borderBottomRadius}px;
    `}
  ${({ isVodDetail }) => {
    return (
      isVodDetail &&
      `
        ${mq.pc} {
          background-size: 50% auto;
        }

        ${mq.tablet} {
          background-size: 100% auto;
        }
      `
    );
  }}
`;
